(() => {
  "use strict";

  if (window.__P12_RUNNING__) return;
  window.__P12_RUNNING__ = true;

  const html = document.documentElement;

  if (!window.CSS) window.CSS = {};
  if (!CSS.escape) {
    CSS.escape = function (value) {
      return String(value).replace(/[^a-zA-Z0-9_\u00A0-\uFFFF-]/g, (ch) => "\\" + ch);
    };
  }
  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
      let el = this;
      while (el && el.nodeType === 1) {
        if (el.matches && el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      }
      return null;
    };
  }

  const cfgEl = document.getElementById("P12_CONFIG");
  if (!cfgEl) return;

  let C = {};
  try { C = JSON.parse(cfgEl.textContent || "{}") || {}; } catch { C = {}; }

  const MW = Number(C.maxMobile || 749);
  const ED = !!(window.Shopify && Shopify.designMode);

  const WORKER_HOST = String(C.endpoints?.workerHost || "https://r.lecheybebe.shop").replace(/\/+$/, "");
  const SEED_PATH   = String(C.endpoints?.seedPath || "/_seed");
  const PX_PATH     = String(C.endpoints?.pxPath   || "/px/12");
  const IMG_BASE    = String(C.endpoints?.imgBase  || "/pr/12");

  const CACHE_KEY    = String(C.cacheKey || "k1").trim() || "k1";
  const CACHE_TTL_MS = Number(C.cacheTtlMs || 10 * 60 * 1000);

  const CK = "u";
  const CK_TTL_S = 2592000;

  const RATING = (C.rating || { rating: 4.8, reviews: 1542, label: "Reseñas" });
  const COMPARE_FALLBACK = String(C.compareAtText || "").trim();

  const ANNOUNCE_ON  = (C.announcementEnabled === true) || (String(C.announcementEnabled).toLowerCase() === "true");
  const ANNOUNCE_TXT = String(C.announcementText || "").trim();

  const DESC_FALLBACK_HTML = String(C.blackDescHtml || "").trim();

  const now = () => Date.now();
  const mob = () => {
    try { return window.matchMedia && matchMedia(`(max-width:${MW}px)`).matches; }
    catch { return false; }
  };
  const vpNow = () => (mob() ? "m" : "d");

  const S = { vp: vpNow(), lastApplied: "", lastSig: "", decidedForViewport: null, applying: false };

  function qs(root, sel) { try { return (root || document).querySelector(sel); } catch { return null; } }
  function qsa(root, sel) { try { return Array.from((root || document).querySelectorAll(sel)); } catch { return []; } }

  function scopeRoot() {
    return (
      qs(document, '[data-testid="product-information-details"]') ||
      qs(document, ".product__info-container") ||
      qs(document, ".product__info-wrapper") ||
      qs(document, ".product__info") ||
      qs(document, "main") ||
      document.body
    );
  }

  function titleEl(scope) {
    return (
      qs(scope, '[data-testid="product-title"]') ||
      qs(scope, ".product__title h1") ||
      qs(scope, ".product-title h1") ||
      qs(scope, "h1") ||
      qs(document, "h1")
    );
  }

  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    const cs = window.getComputedStyle ? getComputedStyle(el) : null;
    if (cs && (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) === 0)) return false;
    const r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    return r ? (r.width > 8 && r.height > 8) : true;
  }

  function galleryRoot() {
    const sels = ["#media-gallery","media-gallery",".product__media-list",".product__media",".product__media-wrapper",".product-media-container"];
    const all = [];
    for (let i = 0; i < sels.length; i++) { try { all.push(...qsa(document, sels[i])); } catch {} }
    const uniq = Array.from(new Set(all)).filter(el => el && el.isConnected);
    for (let i = 0; i < uniq.length; i++) {
      if (isVisible(uniq[i]) && !uniq[i].closest("#P12_TOP_BLEED")) return uniq[i];
    }
    return uniq[0] || null;
  }

  function setPending() {
    if (ED || !mob()) return;
    try { html.classList.add("P12_pending"); html.classList.remove("P12_ready"); html.classList.remove("P12_BLACK"); } catch {}
  }
  function setBase() {
    if (ED) return;
    try { html.classList.remove("P12_pending"); html.classList.add("P12_ready"); html.classList.remove("P12_BLACK"); } catch {}
  }
  function setBlack() {
    if (ED) return;
    try { html.classList.remove("P12_pending"); html.classList.add("P12_ready"); html.classList.add("P12_BLACK"); } catch {}
  }
  function setPendingOnceForViewport() {
    if (ED || !mob()) return;
    if (S.decidedForViewport === "m") return;
    setPending();
  }

  function rc(name) {
    try {
      const s = document.cookie || "";
      const a = s.split("; ");
      for (let i = 0; i < a.length; i++) {
        const p = a[i];
        const j = p.indexOf("=");
        if (j > 0 && p.slice(0, j) === name) return decodeURIComponent(p.slice(j + 1));
      }
    } catch {}
    return "";
  }

  function bj(b) { try { return JSON.parse(atob(String(b || ""))); } catch { return null; } }

  function parseCookieMode(uVal) {
    try {
      if (!uVal) return null;
      const dot = uVal.indexOf(".");
      if (dot < 1) return null;
      const o = bj(uVal.slice(0, dot));
      if (!o || typeof o.t !== "number") return null;
      const age = (now() / 1000) - o.t;
      if (age < 0 || age > CK_TTL_S) return null;
      return { black: Number(o.m) === 1 };
    } catch { return null; }
  }

  function readCacheEnvelope() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      const p12 = obj && obj.p12;
      if (!p12 || typeof p12 !== "object") return null;
      if (!p12.ts || !p12.mode) return null;
      if ((now() - p12.ts) > CACHE_TTL_MS) return null;
      return p12;
    } catch { return null; }
  }

  function writeCacheEnvelope(mode, payload) {
    try {
      const obj = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
      obj.p12 = obj.p12 && typeof obj.p12 === "object" ? obj.p12 : {};
      obj.p12.mode = mode;
      obj.p12.ts = now();
      if (mode === "black" && payload && typeof payload === "object") obj.p12.payload = payload;
      else { try { delete obj.p12.payload; } catch {} }
      localStorage.setItem(CACHE_KEY, JSON.stringify(obj));
    } catch {}
  }

  function findNativeReview(scope) {
    if (!scope) return null;
    const sels = [".jdgm-prev-badge",".jdgm-preview-badge",".spr-badge",".loox-rating",".yotpo.bottomLine",".yotpo","[data-testid*='rating']",".rating"];
    for (let i = 0; i < sels.length; i++) {
      const el = qs(scope, sels[i]);
      if (el && isVisible(el)) return el;
    }
    return null;
  }

  function ensureFallbackRating(scope) {
    const h1 = titleEl(scope);
    if (!h1) return null;

    const native = findNativeReview(scope);
    const existing = qs(scope, ".P12_rating[data-p12-fallback='1']");
    if (native) { if (existing) existing.remove(); return native; }

    let wrap = existing;
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "P12_rating";
      wrap.setAttribute("data-p12-fallback", "1");

      const stars = document.createElement("span");
      stars.className = "P12_rating__stars";
      stars.style.setProperty("--rating-fill", `${(Number(RATING.rating || 0) / 5) * 100}%`);

      const text = document.createElement("span");
      text.className = "P12_rating__text";
      text.textContent = `${RATING.rating} (${RATING.reviews} ${RATING.label})`;

      wrap.appendChild(stars);
      wrap.appendChild(text);
    }

    if (!wrap.isConnected) h1.insertAdjacentElement("afterend", wrap);
    return wrap;
  }

  function reviewsAutoHeal() {
    const scope = scopeRoot();
    if (!scope) return;

    ensureFallbackRating(scope);
    setTimeout(() => ensureFallbackRating(scope), 700);
    setTimeout(() => ensureFallbackRating(scope), 1600);

    try {
      if (!window.MutationObserver) return;
      const mo = new MutationObserver(() => ensureFallbackRating(scope));
      mo.observe(scope, { childList: true, subtree: true });
      setTimeout(() => { try { mo.disconnect(); } catch {} }, 2500);
    } catch {}
  }

  function priceContainers(scope) {
    try {
      const root = scope || document;
      let pcs = qsa(root, '[ref="priceContainer"]');
      if (!pcs.length) pcs = qsa(document, '[ref="priceContainer"]');
      return pcs.filter(el => el && el.isConnected);
    } catch { return []; }
  }

  function findPriceNode(pc) {
    if (!pc) return null;
    return (qs(pc, ".price-item--sale") || qs(pc, ".price__sale .price-item") || qs(pc, ".price") || qs(pc, ".price-item") || qs(pc, "span.price") || null);
  }

  function findAllNativeCompareNodes(pc) {
    if (!pc) return [];
    const nodes = [];
    nodes.push(...qsa(pc, ".compare-at-price"));
    nodes.push(...qsa(pc, ".price__compare-at"));
    nodes.push(...qsa(pc, ".price-item--regular"));
    nodes.push(...qsa(pc, "s"));
    return Array.from(new Set(nodes)).filter(n => n && n.isConnected);
  }

  function forcePriceRowInline(scope) {
    try {
      const pcs = priceContainers(scope);
      for (let i = 0; i < pcs.length; i++) {
        const pc = pcs[i];
        pc.setAttribute("data-p12-price-ready", "1");
        pc.style.visibility = "visible";
        pc.style.opacity = "1";
      }
    } catch {}
  }

  function ensureCompareRight(scope) {
    try {
      const pcs = priceContainers(scope);
      for (let k = 0; k < pcs.length; k++) {
        const pc = pcs[k];
        const price = findPriceNode(pc);
        if (!price) continue;

        const fallbackEl = qs(pc, '[data-p12-compare="1"]');
        const nativeNodes = findAllNativeCompareNodes(pc).filter(n => !(n.getAttribute && n.getAttribute("data-p12-compare") === "1"));
        const validNative = nativeNodes
          .map(n => ({ n, t: String(n.textContent || "").replace(/\s+/g, " ").trim() }))
          .filter(x => x.t.length > 0);

        if (validNative.length) {
          const keep = validNative[0].n;
          for (let i = 0; i < validNative.length; i++) { const node = validNative[i].n; if (node !== keep) { try { node.remove(); } catch {} } }
          if (fallbackEl) { try { fallbackEl.remove(); } catch {} }

          keep.style.display = "inline-block";
          keep.style.whiteSpace = "nowrap";
          keep.style.opacity = ".35";
          keep.style.textDecoration = "line-through";
          keep.style.fontSize = "14px";

          if (keep.previousSibling !== price) {
            if (price.nextSibling) pc.insertBefore(keep, price.nextSibling);
            else pc.appendChild(keep);
          }
          pc.setAttribute("data-p12-price-ready", "1");
          continue;
        }

        const txt = String(COMPARE_FALLBACK || "").trim();
        if (!txt) { if (fallbackEl) { try { fallbackEl.remove(); } catch {} } continue; }

        let cmp = fallbackEl;
        if (!cmp) { cmp = document.createElement("span"); cmp.setAttribute("data-p12-compare", "1"); pc.appendChild(cmp); }
        cmp.textContent = txt;

        if (cmp.previousSibling !== price) {
          if (price.nextSibling) pc.insertBefore(cmp, price.nextSibling);
          else pc.appendChild(cmp);
        }
        pc.setAttribute("data-p12-price-ready", "1");
      }
    } catch {}
  }

  async function seedCookie() {
    try {
      await fetch(WORKER_HOST + SEED_PATH, { method: "GET", credentials: "include", cache: "no-store", mode: "cors" });
    } catch {}
  }

  async function fetchP12Payload() {
    try {
      const r = await fetch(WORKER_HOST + PX_PATH, { method: "GET", credentials: "include", cache: "no-store", mode: "cors" });
      if (!r || !r.ok) return null;
      const data = await r.json();
      return {
        title: String(data.title || ""),
        html: String(data.html || ""),
        imgCount: Number(data.imgCount || 0),
        announcementEnabled: !!data.announcementEnabled,
        announcement: String(data.announcement || ""),
        blackDescHtml: String(data.blackDescHtml || ""),
        src: "worker"
      };
    } catch { return null; }
  }

  function preload(url) {
    return new Promise((res) => {
      if (!url) return res();
      const im = new Image();
      im.onload = () => res();
      im.onerror = () => res();
      im.src = url;
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (m) => {
      if (m === "&") return "&amp;";
      if (m === "<") return "&lt;";
      if (m === ">") return "&gt;";
      if (m === '"') return "&quot;";
      return "&#39;";
    });
  }

  function compactHtml(inputHtml) {
    try {
      const s = String(inputHtml || "").trim();
      if (!s) return "";
      const tmp = document.createElement("div");
      tmp.innerHTML = s;

      let lead = "";
      const ps = Array.from(tmp.querySelectorAll("p"));
      for (let i = 0; i < ps.length; i++) {
        const t = (ps[i].textContent || "").replace(/\s+/g, " ").trim();
        if (t.length >= 20) { lead = ps[i].outerHTML; break; }
      }

      const lis = Array.from(tmp.querySelectorAll("li")).slice(0, 5);
      let ul = "";
      if (lis.length) ul = "<ul>" + lis.map(li => `<li><span>${(li.innerHTML || "").trim()}</span></li>`).join("") + "</ul>";

      if (!lead) {
        const t = (tmp.textContent || "").replace(/\s+/g, " ").trim();
        if (!t) return "";
        lead = `<p>${escapeHtml(t.slice(0, 160))}${t.length > 160 ? "…" : ""}</p>`;
      }

      return lead + (ul || "");
    } catch { return String(inputHtml || ""); }
  }

  function resolveMediaUrls(n) {
    const out = [];
    for (let i = 0; i < Math.max(1, n); i++) out.push(`${WORKER_HOST}${IMG_BASE}/${i + 1}`);
    return out;
  }

  function buildBleed(n, announcementText) {
    const bleed = document.createElement("div");
    bleed.id = "P12_TOP_BLEED";

    const aText = String(announcementText || "").trim();
    if (ANNOUNCE_ON && aText) {
      const ann = document.createElement("div");
      ann.className = "P12_announcement";
      ann.textContent = aText;
      bleed.appendChild(ann);
    }

    const slider = document.createElement("div");
    slider.className = "P12_slider";

    const viewport = document.createElement("div");
    viewport.className = "P12_slider__viewport";

    const track = document.createElement("div");
    track.className = "P12_slider__track";
    track.setAttribute("role", "region");
    track.setAttribute("aria-label", "Produktbilder");

    const dots = document.createElement("div");
    dots.className = "P12_slider__dots";

    const urls = resolveMediaUrls(n);
    const btns = [];

    for (let i = 0; i < urls.length; i++) {
      const slide = document.createElement("div");
      slide.className = "P12_slider__slide";

      const img = document.createElement("img");
      img.className = "P12_slider__img";
      img.src = urls[i];
      img.alt = "Produktbild";
      img.decoding = "async";
      img.loading = i === 0 ? "eager" : "lazy";

      slide.appendChild(img);
      track.appendChild(slide);

      const b = document.createElement("button");
      b.type = "button";
      b.className = "P12_slider__dot";
      b.setAttribute("aria-label", `Bild ${i + 1}`);
      b.setAttribute("aria-current", i === 0 ? "true" : "false");
      b.addEventListener("click", () => {
        track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
      });

      dots.appendChild(b);
      btns.push(b);
    }

    let raf = 0;
    const upd = () => {
      raf = 0;
      const idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
      for (let i = 0; i < btns.length; i++) btns[i].setAttribute("aria-current", i === idx ? "true" : "false");
    };
    track.addEventListener("scroll", () => {
      if (raf) return;
      raf = requestAnimationFrame(upd);
    });

    viewport.appendChild(track);
    viewport.appendChild(dots);
    slider.appendChild(viewport);
    bleed.appendChild(slider);

    return bleed;
  }

  function ensureBleedContainer(gal) {
    if (!gal || !gal.parentNode) return null;

    let top = document.getElementById("P12_TOP_BLEED");
    if (!top) {
      top = document.createElement("div");
      top.id = "P12_TOP_BLEED";
      top.setAttribute("data-p12-top", "1");
      gal.parentNode.insertBefore(top, gal);
    } else if (!top.isConnected) {
      top.setAttribute("data-p12-top", "1");
      gal.parentNode.insertBefore(top, gal);
    } else if (top.nextSibling !== gal) {
      gal.parentNode.insertBefore(top, gal);
    }
    return top;
  }

  function clearNode(el) { if (!el) return; while (el.firstChild) el.removeChild(el.firstChild); }

  function hideThemeGallery(gal) { if (!gal) return; gal.setAttribute("data-p12-hide-gallery", "1"); }
  function showThemeGallery(gal) { if (!gal) return; gal.removeAttribute("data-p12-hide-gallery"); }

  function findThemeDescriptionNodes(scope) {
    if (!scope) return [];
    const sels = ['[data-testid="product-description"]',".product__description",".product-description","rte-formatter"];
    const out = [];
    for (let i = 0; i < sels.length; i++) { try { out.push(...qsa(scope, sels[i])); } catch {} }
    return out.filter(n => n && n.isConnected && !n.closest('[data-p12-desc="1"]')).filter(n => !qs(n, '[ref="priceContainer"], product-price'));
  }

  function hideThemeDescription(scope) {
    try {
      const nodes = findThemeDescriptionNodes(scope);
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        const txt = (n.textContent || "").replace(/\s+/g, " ").trim();
        if (txt.length < 40) continue;
        n.setAttribute("data-p12-hide-desc", "1");
      }
    } catch {}
  }

  function showThemeDescription(scope) {
    try {
      const nodes = scope ? qsa(scope, "[data-p12-hide-desc='1']") : [];
      for (let i = 0; i < nodes.length; i++) nodes[i].removeAttribute("data-p12-hide-desc");
    } catch {}
  }

  function applyDesc(scope, htmlStr, src) {
    const h1 = titleEl(scope);
    if (!h1) return;

    let box = qs(scope, '[data-p12-desc="1"]');
    if (!box) {
      box = document.createElement("div");
      box.setAttribute("data-p12-desc", "1");
      box.className = "P12_mobile-desc rte";
      box.style.margin = "12px 0 0";
    }

    ensureFallbackRating(scope);

    const ratingNode = qs(scope, ".jdgm-prev-badge, .jdgm-preview-badge, .spr-badge, .loox-rating, .yotpo.bottomLine, .yotpo, [data-testid*='rating'], .rating, .P12_rating") || null;
    const anchor = ratingNode && ratingNode.isConnected ? ratingNode : h1;

    if (!box.isConnected) anchor.insertAdjacentElement("afterend", box);
    else if (box.previousElementSibling !== anchor) anchor.insertAdjacentElement("afterend", box);

    if (src === "config") box.innerHTML = String(htmlStr || "");
    else box.innerHTML = compactHtml(htmlStr || "");
  }

  function removeDesc(scope) { const box = qs(scope, '[data-p12-desc="1"]'); if (box) box.remove(); }

  function applyTitle(scope, txt) {
    const h1 = titleEl(scope);
    if (!h1) return;
    if (!h1.getAttribute("data-p12-original-title")) h1.setAttribute("data-p12-original-title", h1.textContent || "");
    if (txt && h1.textContent !== txt) h1.textContent = txt;
  }

  function restoreTitle(scope) {
    const h1 = titleEl(scope);
    if (!h1) return;
    const o = h1.getAttribute("data-p12-original-title");
    if (o) h1.textContent = o;
  }

  async function applyBlackMode(payload) {
    const scope = scopeRoot();
    const gal = galleryRoot();
    if (!scope || !gal) { applyBaseMode(); return; }

    const n = Math.max(1, Number(payload?.imgCount || 0) || 5);
    const sig = `n:${n}|t:${String(payload?.title || "").slice(0, 80)}|src:${String(payload?.src || "")}`;

    setPendingOnceForViewport();

    const firstUrl = resolveMediaUrls(n)[0] || "";
    await preload(firstUrl);

    if (!mob() || ED) return;

    forcePriceRowInline(scope);
    ensureCompareRight(scope);
    reviewsAutoHeal();
    hideThemeDescription(scope);

    if (S.lastApplied === "black" && S.lastSig === sig && html.classList.contains("P12_BLACK")) {
      hideThemeGallery(gal);
      setBlack();
      S.decidedForViewport = "m";
      return;
    }

    const top = ensureBleedContainer(gal);
    if (!top) { applyBaseMode(); return; }

    const annText = (payload?.announcementEnabled ? String(payload?.announcement || "").trim() : "") || ANNOUNCE_TXT;

    clearNode(top);
    top.replaceWith(buildBleed(n, annText));
    hideThemeGallery(gal);

    if (payload?.title) applyTitle(scope, payload.title);

    const htmlDesc = String(payload?.blackDescHtml || "").trim() || String(payload?.html || "").trim() || String(DESC_FALLBACK_HTML || "").trim();
    if (htmlDesc) {
      const src = (payload?.blackDescHtml ? "config" : "worker");
      applyDesc(scope, htmlDesc, src);
    }

    S.lastApplied = "black";
    S.lastSig = sig;

    setBlack();
    S.decidedForViewport = "m";

    forcePriceRowInline(scope);
    ensureCompareRight(scope);
    reviewsAutoHeal();
    hideThemeDescription(scope);

    setTimeout(() => { forcePriceRowInline(scope); ensureCompareRight(scope); }, 220);
    setTimeout(() => { forcePriceRowInline(scope); ensureCompareRight(scope); }, 900);
    setTimeout(() => { forcePriceRowInline(scope); ensureCompareRight(scope); }, 1600);
  }

  function applyBaseMode() {
    const scope = scopeRoot();
    const gal = galleryRoot();

    try { qsa(document, "#P12_TOP_BLEED").forEach((n) => { try { n.remove(); } catch {} }); } catch {}

    if (gal) showThemeGallery(gal);

    if (scope) {
      showThemeDescription(scope);
      restoreTitle(scope);
      removeDesc(scope);
      reviewsAutoHeal();
      forcePriceRowInline(scope);
      ensureCompareRight(scope);
    }

    S.lastApplied = "base";
    S.lastSig = "";

    setBase();
    S.decidedForViewport = mob() ? "m" : "d";
  }

  async function decideAndApplyMobile() {
    if (ED || !mob()) { applyBaseMode(); return; }

    setPendingOnceForViewport();

    const parsed = parseCookieMode(rc(CK));
    if (!parsed || !parsed.black) {
      writeCacheEnvelope("base", null);
      applyBaseMode();
      return;
    }

    const env = readCacheEnvelope();
    if (env?.mode === "black" && env?.payload) {
      await applyBlackMode(env.payload);
      return;
    }

    let payload = await fetchP12Payload();
    if (!payload) {
      await seedCookie();
      payload = await fetchP12Payload();
    }

    if (payload && !String(payload.blackDescHtml || "").trim() && DESC_FALLBACK_HTML) payload.blackDescHtml = DESC_FALLBACK_HTML;

    if (payload && (String(payload.title || "").trim() || String(payload.html || "").trim() || String(payload.blackDescHtml || "").trim())) {
      writeCacheEnvelope("black", payload);
      await applyBlackMode(payload);
      return;
    }

    writeCacheEnvelope("base", null);
    applyBaseMode();
  }

  let _pendingMicro = false;

  function sched() {
    if (_pendingMicro) return;
    _pendingMicro = true;

    queueMicrotask(() => {
      _pendingMicro = false;
      if (S.applying) return;
      S.applying = true;

      const vp = vpNow();
      S.vp = vp;

      Promise.resolve()
        .then(() => {
          if (vp === "d") {
            try { html.classList.remove("P12_pending"); } catch {}
            applyBaseMode();
            return;
          }
          return decideAndApplyMobile();
        })
        .catch(() => { try { applyBaseMode(); } catch {} })
        .finally(() => { S.applying = false; });
    });
  }

  const MQL = window.matchMedia ? window.matchMedia(`(max-width:${MW}px)`) : null;

  function hardSwitchToDesktopNOW() {
    try { S.vp = "d"; S.decidedForViewport = "d"; html.classList.remove("P12_pending"); applyBaseMode(); }
    catch { try { applyBaseMode(); } catch {} }
  }

  function hardSwitchToMobileNOW() {
    try { S.vp = "m"; S.decidedForViewport = null; setPendingOnceForViewport(); sched(); }
    catch { try { sched(); } catch {} }
  }

  (function watchBreakpoint() {
    if (!MQL) return;
    S.vp = MQL.matches ? "m" : "d";
    const onChange = (ev) => {
      if (ED) return;
      if (ev && ev.matches) hardSwitchToMobileNOW();
      else hardSwitchToDesktopNOW();
    };
    try { MQL.addEventListener("change", onChange); }
    catch { try { MQL.addListener(onChange); } catch {} }
  })();

  let _rzRAF = 0;
  addEventListener("resize", () => {
    if (_rzRAF) return;
    _rzRAF = requestAnimationFrame(() => {
      _rzRAF = 0;
      if (ED) return;
      const vp = vpNow();
      if (vp !== S.vp) { if (vp === "m") hardSwitchToMobileNOW(); else hardSwitchToDesktopNOW(); }
    });
  }, { passive: true });

  addEventListener("orientationchange", () => {
    if (ED) return;
    const vp = vpNow();
    if (vp !== S.vp) { if (vp === "m") hardSwitchToMobileNOW(); else hardSwitchToDesktopNOW(); }
  }, { passive: true });

  try {
    const s = scopeRoot();
    if (s) { reviewsAutoHeal(); forcePriceRowInline(s); ensureCompareRight(s); }
  } catch {}

  if (!ED && mob()) setPendingOnceForViewport();
  else try { html.classList.remove("P12_pending"); } catch {}

  try {
    const root = qs(document, "main") || document.body || document.documentElement;
    const mo = new MutationObserver(() => {
      const scope = scopeRoot();
      if (!scope) return;
      forcePriceRowInline(scope);
      ensureCompareRight(scope);
      ensureFallbackRating(scope);
      if (html.classList.contains("P12_BLACK")) hideThemeDescription(scope);
    });
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(() => { try { mo.disconnect(); } catch {} }, 3500);
  } catch {}

  (function startCookieWatch() {
    try {
      let last = rc(CK);
      setInterval(() => {
        const cur = rc(CK);
        if (cur === last) return;
        last = cur;

        if (!mob() || ED) return;

        const p = parseCookieMode(cur);
        if (!p || !p.black) {
          try { writeCacheEnvelope("base", null); } catch {}
          S.lastApplied = "";
          S.lastSig = "";
        }
        sched();
      }, 400);
    } catch {}
  })();

  addEventListener("pageshow", () => sched());
  addEventListener("storage", () => sched());

  sched();

  window.__p12 = {
    r: () => sched(),
    cache: () => { try { return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}"); } catch { return {}; } },
    reset: () => {
      try {
        const obj = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
        if (obj && obj.p12) delete obj.p12;
        localStorage.setItem(CACHE_KEY, JSON.stringify(obj));
      } catch {}
      try { qsa(document, "#P12_TOP_BLEED").forEach(n => n.remove()); } catch {}
      S.lastApplied = "";
      S.lastSig = "";
      S.decidedForViewport = null;
      sched();
    }
  };
})();


